import BeoordeeldeIngangsklacht from "./BeoordeeldeIngangsklacht";
import TriageStartModel from "./TriageStartModel";

export default class CalculatieInputModel {
    public triageStart: TriageStartModel;
    public beoordeeldeIngangsklachten: BeoordeeldeIngangsklacht[];
}


